/**
 * Sharing Constants
 * 
 * Centralized constants for invitations and members
 */

import type { MemberRole, InvitationStatus, ModulePermission } from '../../types/sharing';

export const MEMBER_ROLES: Record<MemberRole, string> = {
  owner: 'Proprietário',
  admin: 'Administrador',
  editor: 'Editor',
  viewer: 'Visualizador',
};

export const MEMBER_ROLE_DESCRIPTIONS: Record<MemberRole, string> = {
  owner: 'Acesso total e gerenciamento da empresa',
  admin: 'Gerenciar membros e todas as funcionalidades',
  editor: 'Criar e editar lançamentos, orçamentos e relatórios',
  viewer: 'Apenas visualizar informações',
};

export const INVITATION_STATUS_LABELS: Record<InvitationStatus, string> = {
  pending: 'Pendente',
  accepted: 'Aceito',
  expired: 'Expirado',
  cancelled: 'Cancelado',
};

export const INVITATION_STATUS_VARIANTS: Record<InvitationStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  pending: 'default',
  accepted: 'secondary',
  expired: 'outline',
  cancelled: 'destructive',
};

export const MODULE_PERMISSION_LABELS: Record<ModulePermission, string> = {
  full: 'Total',
  write: 'Escrita',
  read: 'Leitura',
  none: 'Nenhum',
};

export const MODULE_NAMES = {
  transactions: 'Lançamentos',
  budgets: 'Orçamentos',
  reports: 'Relatórios',
  scenarios: 'Cenários',
  settings: 'Configurações',
};

export const DEFAULT_PERMISSIONS_BY_ROLE: Record<MemberRole, Partial<Record<keyof typeof MODULE_NAMES, ModulePermission>>> = {
  owner: {
    transactions: 'full',
    budgets: 'full',
    reports: 'full',
    scenarios: 'full',
    settings: 'full',
  },
  admin: {
    transactions: 'full',
    budgets: 'full',
    reports: 'full',
    scenarios: 'full',
    settings: 'write',
  },
  editor: {
    transactions: 'write',
    budgets: 'write',
    reports: 'write',
    scenarios: 'write',
    settings: 'none',
  },
  viewer: {
    transactions: 'read',
    budgets: 'read',
    reports: 'read',
    scenarios: 'read',
    settings: 'none',
  },
};
